import { useSearchParams  } from "react-router-dom";

function IframeRedirectTest() {

   const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get('redirectTo');

  const onSubmit = (event) => {
    event.preventDefault();

    console.log("Form submitted");


   

    
    //Select the parent window
    const parentWindow = window.parent;
   
    
    parentWindow.location.href = redirectTo;

    console.log("Parent window URL:", parentWindow.location);
  };

  return (
    <div className="flex flex-col  bg-gray-100">
      {/*Create a simple form form*/}
      <form className="flex flex-col gap-4 p-10" onSubmit={onSubmit}>
        <label htmlFor="name">Name:</label>
        <input
          type="text"
          id="name"
          name="name"
          required
          className="border border-gray-300 p-2 rounded"
        />
        <label htmlFor="email">Email:</label>
        <input
          type="text"
          id="email"
          name="email"
          required
          className="border border-gray-300 p-2 rounded"
        />
        <label htmlFor="message">Message:</label>
        <textarea
          id="message"
          name="message"
          required
          className="border border-gray-300 p-2 rounded"
          rows="4"
        ></textarea>
        <button
          type="submit"
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors duration-200"
        >
          Submit
        </button>
      </form>
    </div>
  );
}

export default IframeRedirectTest;
